import React, { useMemo } from 'react'
import { Calendar, Views, momentLocalizer } from 'react-big-calendar'
import moment from 'moment'
import { useTimeTablesDataDigest } from '../../../local'
import CustomToolbar from './CustomToolbar'
import CustomWeek from './CustomWeek'
import './WeeklyTimeTable.scss'
import sampleTimeTableList from './events.json'
import { first } from 'lodash'

/**
 * @typedef {Object} CustomViewProps
 */

/**
 * @typedef {Object} CustomHeaderProps
 * @property {string} label
 */

/**
 * Custom day column header.
 * @param {CustomHeaderProps} label
 * @return {JSX.Element}
 * @constructor
 */
const CustomHeader = ({ label }) => (
  <div>
    <div>{label}</div>
  </div>
)

const localizer = momentLocalizer(moment)

/**
 * @typedef {import('../../../definitions').TimeTableRecord} TimeTableRecord
 */

/**
 * @typedef {Object} WeeklyTimeTableProps
 * @property {TimeTableRecord[]} timeTableList
 */

/**
 * Custom work weekly calendar view.
 * @param {WeeklyTimeTableProps} props
 * @return {JSX.Element}
 */
export default function WeeklyTimeTable({ timeTableList = sampleTimeTableList }) {
  const firstDate = first(timeTableList)

  const startDate = firstDate ? new Date(firstDate.startDate) : new Date()
  const { defaultDate, views, components } = useMemo(
    () => ({
      defaultDate: startDate,
      components: {
        header: CustomHeader,
        toolbar: CustomToolbar,
      },
      views: {
        // agenda: true,
        week: CustomWeek,
      },
    }),
    []
  )

  const { digestTimeTableList } = useTimeTablesDataDigest()
  const calendarEvents = useMemo(() => digestTimeTableList(timeTableList), [timeTableList])

  return (
    <>
      <div className="weekly-time-table">
        <Calendar
          components={components}
          defaultDate={defaultDate}
          defaultView={Views.WEEK}
          events={calendarEvents}
          localizer={localizer}
          views={views}
          step={15}
          timeslots={2}
          formats={{
            timeGutterFormat: 'HH:mm',
          }}
          min={ new Date(1972, 0, 1, 7) }
          max={ new Date(1972, 0, 1, 21, 59, 59) }
          popup
        />
      </div>
    </>
  )
}
